<button [disabled]="disabled" [type]="type" #button class="btn">
    <ng-content></ng-content>
</button>